(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTestimonialSlider(section) {
    var track = section.querySelector('.lureya-testimonials__track');
    var dotsContainer = section.querySelector('.lureya-testimonials__dots');
    if (!track || !dotsContainer) return;

    var cards = track.querySelectorAll('.lureya-testimonial-card');
    if (cards.length < 2) return;

    function buildDots() {
      if (window.innerWidth > 749) {
        dotsContainer.innerHTML = '';
        return;
      }
      if (dotsContainer.children.length === cards.length) return;
      dotsContainer.innerHTML = '';
      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsContainer.appendChild(b);
      });
    }

    function updateActiveDot() {
      if (window.innerWidth > 749) return;
      var dots = dotsContainer.children;
      if (!dots.length) return;
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closestIdx = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var cardCenter = r.left + r.width / 2;
        var dist = Math.abs(cardCenter - trackCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      });
      Array.prototype.forEach.call(dots, function (d, i) {
        if (i === closestIdx) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    buildDots();
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateActiveDot);
    }, { passive: true });
    window.addEventListener('resize', function () {
      buildDots();
      updateActiveDot();
    });
  }

  function initAll() {
    document.querySelectorAll('.lureya-testimonials-section').forEach(initTestimonialSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
